import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';

import connect from "react-redux/es/connect/connect";
import ContentContainer from "../elements/ContentContainer";
import Defines from "../../Defines";

class EconomyEarned extends Component {
  static propTypes = {
    title: PropTypes.string,
    top: PropTypes.number,
    left: PropTypes.number,
    feedbackCount: PropTypes.number,
    roundPoints: PropTypes.number,
    economy: PropTypes.number,
  }
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { gameState, feedback, schoolClass } = this.props;
    const { currentRound } = gameState;
    const currentRoundGameState = gameState.Rounds[currentRound];

    // Retrieve ID of current round game
    // Get associated game object from SchoolClass
    // Retrieve game icon for display from game object
    const { GameId } = currentRoundGameState;
    const gameObject = schoolClass.SchoolClassGames.find(game => game.GameId === GameId);
    const gameIcon = Defines.gameLogos.find((icon) => icon.abbreviation === gameObject.Game.abbreviation).logo || "";
    if(!gameState.prevRound || !feedback.prevRoundFeedbackData) return null;

    return (
      <div>
        <ContentContainer>
          {__('sim_globas_punten_verdiend_met_uitleg')}:

          <div className={"games-points"}>
            <div className={"game-img"}>
              {gameIcon ? <img alt="gameIcon" src={gameIcon}/> : ""}
            </div>
            <div className={"globas-points"}>
              <div>
                {currentRound === 5 ? '-' : currentRoundGameState.earnedGlobas} {__('sim_miljard')}
              </div>
              <div>
                {currentRound === 5 ? '-' : currentRoundGameState.earnedPoints} {__('sim_punten')}
              </div>
            </div>
          </div>
        </ContentContainer>
      </div>
    );
  }
}

export default connect(({gameState, feedback, schoolClass}) => ({gameState, feedback, schoolClass}))(EconomyEarned);



// WEBPACK FOOTER //
// ./src/components/elements/EconomyEarned.js